/**
 * Selects the index of the first available tab based on permissions and state.
 *
 * Rules:
 * - If `preferredIndex` is valid and the tab is available, it is kept.
 * - A tab is considered available if:
 *   - It does not require permission (`permissionCode` is undefined) or `isAuthenticated(permissionCode)` is true.
 * - If no tab is available, returns `null`.
 *
 * @param {Array<{title:string, component:any, to?:string, permissionCode?:string, disableTab?:boolean}>} componentsInfo
 * List of tabs in priority order.
 * @param {(code?:string)=>boolean} isAuthenticated
 * Function to validate user permissions.
 * @param {number|undefined} preferredIndex
 * Initially desired index (e.g., the currently selected one).
 * @returns {number|null} Index of the selected tab or `null` if none are available.
 */
export function selectFirstAvailableTab (componentsInfo, isAuthenticated, preferredIndex) {
  const isTabAvailable = (info) => {
    if (info?.permissionCode === undefined) return true
    return !!isAuthenticated(info.permissionCode)
  }

  if (Number.isInteger(preferredIndex) && preferredIndex >= 0 && preferredIndex < componentsInfo.length) {
    if (isTabAvailable(componentsInfo[preferredIndex])) {
      return preferredIndex
    }
  }

  for (let i = 0; i < componentsInfo.length; i++) {
    if (isTabAvailable(componentsInfo[i])) {
      return i
    }
  }

  return null
}
